import request from "@/utils/request";

const api = {
    Detail: "/admin/app/detail",
    DetailByCode: "/admin/app/detailByCode",
    PlatformList: "/admin/app/platformList",
    SystemList: "/admin/app/systemList",
    SystemAppList: "/admin/app/systemAppList",
    ThirdAppList: "/admin/app/thirdAppList",
    AllPlatformApp: "/admin/app/allPlatformApp",
    AllSystemScopeApp: "/admin/app/allSystemScopeApp",
    EditAppStatus: "/admin/app/status",
    EditAppInfo: "/admin/app/editAppInfo",
    getAppByChatId: "/admin/app/getByChatId",
    updateSystemAdministrator: "/admin/app/updateAdmin",
    platformTree: '/admin/app/tree',
    targetPlatformSsoUrl: '/admin/app/targetPlatformSso',
    SaveThirdApp: '/admin/app/saveThirdApp'
};

export function getAppDetail(parameter) {
    return request({
        url: api.Detail,
        method: "get",
        params: parameter,
    });
}

export function getPlatformList(parameter) {
    return request({
        url: api.PlatformList,
        method: "get",
        params: parameter,
    });
}

export function getSystemList(parameter) {
    return request({
        url: api.SystemList,
        method: "get",
        params: parameter,
    });
}

export function getThirdAppList(parameter) {
    return request({
        url: api.ThirdAppList,
        method: "get",
        params: parameter,
    });
}

export function getSystemAppList(parameter) {
    return request({
        url: api.SystemAppList,
        method: "get",
        params: parameter,
    });
}

export function getAllPlatformApp(parameter) {
    return request({
        url: api.AllPlatformApp,
        method: "get",
        params: parameter,
    });
}

export function getAllSystemScopeApp(parameter) {
    return request({
        url: api.AllSystemScopeApp,
        method: "get",
        params: parameter,
    });
}

export function editAppStatus(parameter) {
    return request({
        url: api.EditAppStatus,
        method: "post",
        data: parameter,
    });
}

export function editAppInfo(parameter) {
    return request({
        url: api.EditAppInfo,
        method: "post",
        data: parameter,
    });
}

export function getAppByChatId(parameter) {
    return request({
        url: api.getAppByChatId,
        method: "get",
        params: parameter,
    });
}

export function updateSystemAdministrator(parameter) {
    return request({
        url: api.updateSystemAdministrator,
        method: 'post',
        data: parameter
    })
}

export function getPlatformTree() {
    return request({
        url: api.platformTree,
        method: 'get'
    })
}

export function saveThirdApp(parameter) {
    return request({
        url: api.SaveThirdApp,
        method: 'post',
        data: parameter
    })
}
